var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Chip',{attrs:{"category":"green"}},[_vm._v(" "+_vm._s(_vm.$t('myAssignments.assignmentRow.open'))+" "+_vm._s(_vm.formattedTimeDifference)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }